export default __webpack_public_path__ + "static/media/reported.9032b8a2.svg";